import styled from "styled-components";
import { Box } from "@material-ui/core";

export const UserPageExplanationWrapper: any = styled(Box)`
    width: 100%;
    background-color: #f2f1f1;
    padding: 60px 15px;

    /* Really don't like using a stylized autogrid ignores the styles so have to wrap it. */
    #userpagegrid {
        width: 100%;
        max-width: 1140px;
        margin: 0 auto;
    }
`;

export const UserPageDescriptionWrapper: any = styled(Box)`
    width: 100%;
    padding: 60px 15px 30px 15px;

    /* Really don't like using a stylized autogrid ignores the styles so have to wrap it. */
    #descriptiongrid {
        width: 100%;
        max-width: 1140px;
        margin: 0 auto;
    }
`;
